var map = {
	"./align-justify-regular.svg": "O8Xr",
	"./barcode-solid.svg": "1chV",
	"./bars-solid.svg": "FlLM",
	"./bell-light.svg": "Zku+",
	"./chart-pie-light.svg": "N0kZ",
	"./check-circle-light.svg": "DhjE",
	"./chevron-down-light.svg": "uE2J",
	"./chevron-up-light.svg": "Uzfe",
	"./close.svg": "3Y5n",
	"./dashboard.svg": "rVrn",
	"./delete.svg": "Xfz0",
	"./download.svg": "uXUp",
	"./ellipsis-v-solid.svg": "pKrz",
	"./email.svg": "35Dk",
	"./eventos.svg": "1Fgt",
	"./excel.svg": "gZzE",
	"./exclamation-circle-light.svg": "d6wH",
	"./exit.svg": "aIxC",
	"./facebook.svg": "ZQBq",
	"./file-alt-light.svg": "E9Tr",
	"./financeiro.svg": "VnsN",
	"./font-case-light.svg": "ySrj",
	"./list-ul-solid.svg": "GTJy",
	"./location.svg": "FzS+",
	"./mouse-alt-light.svg": "Hc8r",
	"./newsletter.svg": "c4cY",
	"./noticias.svg": "vRpn",
	"./paper-plane-solid.svg": "ibdd",
	"./pencil.svg": "c8Ul",
	"./publish.svg": "h+XP",
	"./save.svg": "TU11",
	"./search-light.svg": "CJWq",
	"./search.svg": "ma5/",
	"./sindicatos.svg": "cdHb",
	"./star.svg": "ua82",
	"./tv.svg": "d8Vg",
	"./twitter.svg": "XfUh",
	"./user-plus-solid.svg": "ZBbd",
	"./user-plus.svg": "Pv98",
	"./video.svg": "reKb",
	"./youtube.svg": "gfs2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wnrk";